module.exports = __webpack_public_path__ + "static/media/Evira final Cam 01-1-mobile.a5998db0.webp";